import { render, staticRenderFns } from "./clause.vue?vue&type=template&id=5ddcc48c&scoped=true&"
import script from "./clause.vue?vue&type=script&lang=js&"
export * from "./clause.vue?vue&type=script&lang=js&"
import style0 from "./clause.vue?vue&type=style&index=0&id=5ddcc48c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddcc48c",
  null
  
)

export default component.exports